import { useLayoutEffect, useState } from "react";
import useScreenSize from "./useScreenSize";

const PORTABLE_SCREEN_WIDTH_BOUNDARY = 768; //px

// Use case is the navbar
const useMobileSize = () => {
    const [width] = useScreenSize();
    const [isMobileSize, setMobileSize] = useState(false);

    // Prevent UI from rendering before determining screen size
    useLayoutEffect(() => {
        setMobileSize(width < PORTABLE_SCREEN_WIDTH_BOUNDARY);
    }, [width]);

    return [isMobileSize];
};

export default useMobileSize;
